var app = angular.module('app')
    .directive('resetSearchModel', [resetSearchModel]);
function resetSearchModel () {
    return {
        restrict: 'A',
        require: ['^ngModel','uiSelect'],
        link: function (scope, element, attrs, ctrls) {
            scope.$watch(attrs.ngModel,function (newval,oldval,scope) {
                if (newval != undefined && newval.length < 1){
                    scope.$select.selected = undefined;
                }
            });
        }
    };
}